// @flow
import * as React from 'react';
import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';

import EventAdd from './calendar.event-add.js';

type OwnProps = {||};

type MappedState = {|
  event: event
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class EventEdit extends React.Component<Props> {
  static footer = true;

  render() {
    const { event } = this.props;

    if (!event || !event.id) return null;

    if (event.inFlight === '1')
      return <EventAdd switchModals={this.props.switchModals} edit inFlight />;

    if (event.inFlight !== '1' && event.completed !== '1')
      return <EventAdd switchModals={this.props.switchModals} edit />;

    if (event.completed === '1')
      return <EventAdd switchModals={this.props.switchModals} edit completed />;
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  event: state.event
});

export default connect(
  mapStateToProps,
  {}
)(EventEdit);
